import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { UserId, Account } from '../constant'
import { requestLoginAsync } from '../../api'
import jwt_decode from 'jwt-decode'
import { setStorage, rmStorage } from '../../utils/storage'

const initialState = {
  [UserId]: 0,
  [Account]: '',
  exp: 0
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (_, { payload }) => {
      return payload
    },
    update: (state, { payload }) => ({ ...state, ...payload }),
    logout: (_) => {
      rmStorage('accessToken')
      rmStorage('refreshToken')
      return initialState
    }
  },
  extraReducers(builder) {
    builder.addCase(loginAsync.fulfilled, (_, { payload }) => { return payload })
  }
})

export const { login, update, logout } = userSlice.actions

// export const loginAsync = (data, callback) => {
//   return async dispatch => {
//     const res = await requestLoginAsync(data)
//     if (res === null || res === '') return
//     const payload = jwt_decode(res)
//     dispatch(login(payload))
//     setStorage('accessToken', res)
//     callback && callback()
//   }
// }

export const loginAsync = createAsyncThunk('user/loginAsync', async ({ data, callback }) => {
  const res = await requestLoginAsync(data)
  if (res === null || res === '') return
  const payload = jwt_decode(res)
  setStorage('accessToken', res)
  callback && callback()
  return payload
})

export default userSlice.reducer